import React, { useEffect, useState } from "react";
import "./Testimonials.css";
import api from "../Api.js";

export default function JoyrajTestimonials() {
  const [current, setCurrent] = useState(0);
  const [testimonial, setTestimonial] = useState([]);

  /* Fetch testimonials */
  useEffect(() => {
    const getTestimonials = async () => {
      try {
        const response = await api.get("/testimonials");
        if (response?.data?.status === true) {
          setTestimonial(response.data.data || []);
        }
      } catch (error) {
        console.error("Failed to fetch testimonials", error);
      }
    };

    getTestimonials();
  }, []);

  /* Auto slide (only when data exists) */
  useEffect(() => {
    if (testimonial.length === 0) return;

    const timer = setInterval(() => {
      setCurrent((prev) =>
        prev === testimonial.length - 1 ? 0 : prev + 1
      );
    }, 4000);

    return () => clearInterval(timer);
  }, [testimonial]);

  const prevSlide = () => {
    if (testimonial.length === 0) return;
    setCurrent((prev) =>
      prev === 0 ? testimonial.length - 1 : prev - 1
    );
  };

  const nextSlide = () => {
    if (testimonial.length === 0) return;
    setCurrent((prev) =>
      prev === testimonial.length - 1 ? 0 : prev + 1
    );
  };

  if (testimonial.length === 0) {
    return (
      <section className="joyraj-testimonial-section">
        <p className="joyraj-loading">Loading testimonials...</p>
      </section>
    );
  }

  const active = testimonial[current];

  return (
    <section className="joyraj-testimonial-section">
      <div className="joyraj-testimonial-wrapper">
        <div className="joyraj-testimonial-header">
          <h2>Testimonials</h2>
          <div className="joyraj-testimonial-controls">
            <button onClick={prevSlide}>‹</button>
            <button onClick={nextSlide}>›</button>
          </div>
        </div>

        <div className="joyraj-testimonial-card">
          <img
            src={active?.photo_url}
            alt={active?.name}
          />
          <p className="joyraj-review">
            “{active?.comment}”
          </p>
          <h4>{active?.name}</h4>
          <span>{active?.designation}</span>
        </div>
      </div>
    </section>
  );
}
